<template>
  <CandidateOpportunities v-if="role === 'candidate'" />
</template>

<script>
import CandidateOpportunities from '@/views/candidates/Opportunities'
export default {
  components: { CandidateOpportunities },
  computed: {
    role() {
      return this.$store.getters['auth/role']
    },
  },
}
</script>
